import login from "./login";
import schedulePageLoad from "./shifts-definitions/page-load";
import requestCreateShiftDefinition from "./shifts-definitions/request-create";
import requestUpdateShiftDefinition from "./shifts-definitions/request-update";
import requestMoveShiftDefinition from "./shifts-definitions/request-move";
import requestDeleteShiftDefinition from "./shifts-definitions/request-delete";
// Users
import usersPageLoad from "./users/list-page-load";
import userPageLoad from "./users/edit-page-load";
import requestAddUser from "./users/request-add";
import requestChangeUsername from "./users/request-change-username";
import changedUsername from "./users/changed-username";
import requestChangePassword from "./users/request-change-password";
import requestEnableUser from "./users/request-enable";
import requestDisableUser from "./users/request-disable";
// Regions
import regionsPageLoad from "./regions/list-page-load";
import regionPageLoad from "./regions/edit-page-load";
import requestAddRegion from "./regions/request-add";
import requestUpdateRegion from "./regions/request-update";
import requestAddEmailToRegion from "./regions/request-add-email";
import requestDeleteEmailFromRegion from "./regions/request-delete-email";
// Cities
import citiesPageLoad from "./cities/list-page-load";
import cityPageLoad from "./cities/edit-page-load";
import requestAddCity from "./cities/request-add";
import requestUpdateCity from "./cities/request-update";
// Engineers
import engineersPageLoad from "./engineers/list-page-load";
import engineerPageLoad from "./engineers/edit-page-load";
import requestAddEngineer from "./engineers/request-add";
import requestUpdateEngineer from "./engineers/request-update";
import requestAddEmailToEngineer from "./engineers/request-add-email";
import requestDeleteEmailFromEngineer from "./engineers/request-delete-email";
import engineersSearchPageLoad from "./engineers/search-page-load";
// Partners
import partnersPageLoad from "./partners/list-page-load";
import partnerPageLoad from "./partners/edit-page-load";
import requestAddPartner from "./partners/request-add";
import requestUpdatePartner from "./partners/request-update";
import requestAddQueueToPartner from "./partners/request-add-queue";
import requestDeleteQueueFromPartner from "./partners/request-delete-queue";
import requestUploadLogoToPartner from "./partners/request-upload-logo";
import requestDeleteLogoFromPartner from "./partners/request-delete-logo";
import partnerLoadLogo from "./partners/logo-load";
// Global settings
import globalSettingsPageLoad from "./global-settings/edit-page-load";
import requestUpdateSettings from "./global-settings/request-update";
import requestAddEmailToSettings from "./global-settings/request-add-email";
import requestDeleteEmailFromSettings from "./global-settings/request-delete-email";
//others
import scheduleStatus from "./schedule-status-page-load";
import engineerSearchNeedleChanged from "./engineer-search-needle-changed";
import refreshUnstableFeaturesStatusOnLoad from "../../../../sagas/unstable-features/refresh-unstable-features-status-on-load";

export const appSagas = [
  refreshUnstableFeaturesStatusOnLoad,
  login,
  // users
  usersPageLoad,
  userPageLoad,
  requestAddUser,
  requestChangeUsername,
  changedUsername,
  requestChangePassword,
  requestEnableUser,
  requestDisableUser,
  // scheduling
  schedulePageLoad,
  requestCreateShiftDefinition,
  requestUpdateShiftDefinition,
  requestMoveShiftDefinition,
  requestDeleteShiftDefinition,
  // Region
  regionsPageLoad,
  regionPageLoad,
  requestAddRegion,
  requestUpdateRegion,
  requestAddEmailToRegion,
  requestDeleteEmailFromRegion,
  // Cities
  citiesPageLoad,
  cityPageLoad,
  requestAddCity,
  requestUpdateCity,
  // Engineer
  engineersPageLoad,
  engineerPageLoad,
  requestAddEngineer,
  requestUpdateEngineer,
  requestAddEmailToEngineer,
  requestDeleteEmailFromEngineer,
  engineersSearchPageLoad,
  // Partners
  partnersPageLoad,
  partnerPageLoad,
  requestAddPartner,
  requestUpdatePartner,
  requestAddQueueToPartner,
  requestDeleteQueueFromPartner,
  requestUploadLogoToPartner,
  requestDeleteLogoFromPartner,
  partnerLoadLogo,
  // Global settings
  globalSettingsPageLoad,
  requestUpdateSettings,
  requestAddEmailToSettings,
  requestDeleteEmailFromSettings,
  //Others
  scheduleStatus,
  engineerSearchNeedleChanged,
];



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/app-sagas.js